import { Card, Tabs } from "antd";
import "./feature-activity-card.scss";
import { ActivityCardPermissions } from "models/types";
import ErrorBoundary from "components/error-boundary";
import FeatureCommentsTabComponent from "./feature-comments-tab";
import { useCommentsCountLabel } from "./use-comments-count-label";

function FeatureActivityCard(props: {
  historyTabContents: any;
  permissions: ActivityCardPermissions;
  isAttachementFeatureEnabled: boolean;
  showHistoryTab?: boolean;
  featureKey: string;
  featureId: string;
  auditFeatureType?: string;
}) {
  const {
    historyTabContents,
    permissions,
    showHistoryTab = true,
    isAttachementFeatureEnabled,
    featureKey,
    featureId,
    auditFeatureType
  } = props;

  const { label: commentsLabel, onCommentsCountChange } =
    useCommentsCountLabel(featureId);

  const tabItems = [
    {
      label: commentsLabel,
      key: "1",
      children: (
        <ErrorBoundary>
          <FeatureCommentsTabComponent
            permissions={permissions}
            featureKey={featureKey}
            featureId={featureId}
            isAttachementFeatureEnabled={isAttachementFeatureEnabled}
            auditFeatureType={auditFeatureType}
            onCommentsCountChange={onCommentsCountChange}
          />
        </ErrorBoundary>
      )
    },
    {
      label: "History",
      key: "2",
      children: historyTabContents
    }
  ];

  if (!showHistoryTab) {
    tabItems.splice(1, 1);
  }

  return (
    <Card className="activity-card ciq-card-block">
      <div className="h-full max-h-full">
        <Tabs items={tabItems} />
      </div>
    </Card>
  );
}

export default FeatureActivityCard;
